<div class="block--wrap block">
    <div class="ticket" ridangoMatchHeight="block-full-width">
        <div class="border-bottom-line-text margin-bottom-20 margin-top-30">
            <p class="margin-bottom-20 bold">{{ 'PAYMENT_RESULT_TEXT_RECEIVE_TICKETS_INVOICE' | translate }}</p>
        </div>

        <div class="block-half-width e-mail margin-bottom-20">
            <div class="block-full-width align-center">
                <div class="margin-bottom-10">
                    <mat-icon>mail</mat-icon>
                </div>

                <div class="title margin-bottom-20">{{ 'SEND_INVOICE_EMAIL' | translate }}</div>

                <form [formGroup]="invoiceForm" (ngSubmit)="sendInvoiceToEmail()" ridangoFocusInvalidInput>
                    <div class="checkout-receipt__col-email">
                        <ridango-form-field>
                            <input ridangoInput name="email" formControlName="email" />
                            <ridango-label>{{ 'PH_EMAIL' | translate }}</ridango-label>
                            <ridango-error
                                *ngIf="
                                    invoiceForm.controls.email.hasError('email') &&
                                    !invoiceForm.controls.email.hasError('required')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
                            </ridango-error>
                            <ridango-error
                                *ngIf="
                                    invoiceForm.controls.email.touched &&
                                    invoiceForm.controls.email.hasError('required')
                                ">
                                {{ 'LOCAL_INPUT_EMAIL_MISSING' | translate }}
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="checkout-receipt__col-send">
                        <button class="btn btn--big btn--primary btn--maximal" type="submit">
                            {{ 'BTN_SEND' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div class="block-half-width pdf last">
            <div class="block-full-width align-center">
                <div class="margin-bottom-10">
                    <mat-icon>download</mat-icon>
                </div>

                <div class="title margin-bottom-20">{{ 'PAYMENT_RESULT_TEXT_SAVE_RECEIPT_PDF' | translate }}</div>

                <button
                    class="btn btn--maximal btn--big btn--primary"
                    *ngIf="!(loading$ | async)"
                    (click)="downloadInvoice()"
                    (keydown.enter)="downloadInvoice()"
                    (keydown.space)="downloadInvoice()"
                    tabindex="0">
                    {{ 'DOWNLOAD_INVOICE' | translate }}
                </button>
                <button class="btn btn--maximal btn--big btn--primary" *ngIf="loading$ | async" disabled>
                    <span class="btn-loader">
                        <span>
                            <span class="btn-loader__img"
                                ><img class="dark:filter-black" src="assets/button_loader.png"
                            /></span>
                            <span class="btn-loader__text">{{ 'BUTTON_LOADER_TEXT' | translate }}</span>
                        </span>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
